/* Kkumi loading-skeleton helper (JS side).
 *
 * Mirrors snippets/kkumi-skeleton.liquid for scripts that build DOM at runtime
 * (guest track page, any deferred UI). Both emit the same `.kk-skel` shimmer
 * node — the universal storefront loader. Shimmer + reduced-motion live once in
 * assets/kkumi-tokens.css.
 *
 * Usage:
 *   KKSkel.el({ w: '70%', h: 14 })          // <span class="kk-skel" style="…">
 *   KKSkel.el({ fill: true })               // <div class="kk-skel kk-skel--fill">
 *   KKSkel.html({ class: 'kk-skel--t' })    // markup string
 *   KKSkel.el({ w: 170, text: '0,000' })    // height = one line box of the
 *                                           // parent's real type
 *
 * Options (all optional): fill, w, h, radius, tag ('span'|'div'), class, style,
 * text. Numbers become px; strings ('70%', '14px') pass through. `text` renders
 * placeholder copy inside the bar — `.kk-skel` paints it transparent, so the bar
 * measures the true line box of the text it stands in for instead of a guessed
 * `h` (see the snippet's header comment). Pass `w`, not `h`, alongside it.
 */
(function () {
  'use strict';
  if (window.KKSkel) return;

  function len(v) { return typeof v === 'number' ? v + 'px' : v; }

  function parts(o) {
    o = o || {};
    var tag = o.fill ? 'div' : (o.tag || 'span');
    var cls = 'kk-skel' + (o.fill ? ' kk-skel--fill' : '') + (o['class'] ? ' ' + o['class'] : '');
    // A `text` bar fills a whole line box, so stacked lines would touch: inset it (see .kk-skel--line).
    if (o.text && !o.fill && cls.indexOf('kk-skel--flow') < 0) { cls += ' kk-skel--line'; }
    var style = '';
    if (!o.fill) {
      if (o.w != null) { style += 'width:' + len(o.w) + ';'; }
      if (o.h != null) { style += 'height:' + len(o.h) + ';'; }
    }
    if (o.radius != null) { style += 'border-radius:' + len(o.radius) + ';'; }
    if (o.style) { style += o.style; }
    return { tag: tag, cls: cls, style: style, text: o.text || '' };
  }

  window.KKSkel = {
    el: function (o) {
      var p = parts(o), n = document.createElement(p.tag);
      n.className = p.cls;
      if (p.style) { n.style.cssText = p.style; }
      if (p.text) { n.textContent = p.text; }
      n.setAttribute('aria-hidden', 'true');
      return n;
    },
    html: function (o) {
      var p = parts(o);
      return '<' + p.tag + ' class="' + p.cls + '"' +
        (p.style ? ' style="' + p.style + '"' : '') +
        ' aria-hidden="true">' + (p.text ? window.KKEsc(p.text) : '') + '</' + p.tag + '>';
    }
  };
})();
